import { useState, useEffect } from 'react';
import api from '../../api';

const BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').replace('/api', '');

export default function SuperCatalog() {
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ]             = useState('');
  const [editing, setEditing] = useState(null);
  const [form, setForm]       = useState({});
  const [saving, setSaving]   = useState(false);
  const [uploading, setUploading] = useState({});
  const [uploadingTrailer, setUploadingTrailer] = useState({});
  const [preview, setPreview] = useState(null);

  useEffect(() => { load(); }, []);

  const load = () => {
    setLoading(true);
    api.get('/admin/game-catalog').then(r => setList(r.data || [])).finally(() => setLoading(false));
  };

  const filtered = list.filter(g =>
    !q || g.name.toLowerCase().includes(q.toLowerCase()) || (g.slug || '').toLowerCase().includes(q.toLowerCase())
  );

  const openEdit = (g) => {
    setEditing(g.id);
    setForm({ name: g.name, slug: g.slug, cover_url: g.cover_url || '', trailer_url: g.trailer_url || '',
      platform: g.platform || '', genre: g.genre || '', publisher: g.publisher || '',
      age_rating: g.age_rating || 0, sort_order: g.sort_order || 0, is_active: g.is_active !== false });
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/game-catalog/${editing}`, form);
      setList(l => l.map(g => g.id === editing ? { ...g, ...form } : g));
      setEditing(null);
    } catch (e) {
      alert(e.response?.data?.error || 'Xatolik');
    } finally { setSaving(false); }
  };

  const uploadCover = async (id, file) => {
    setUploading(u => ({ ...u, [id]: true }));
    try {
      const fd = new FormData();
      fd.append('cover', file);
      const r = await api.post(`/admin/game-catalog/${id}/upload-cover`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setList(l => l.map(g => g.id === id ? { ...g, cover_url: r.data.cover_url } : g));
    } catch (e) {
      alert(e.response?.data?.error || 'Yuklashda xatolik');
    } finally {
      setUploading(u => ({ ...u, [id]: false }));
    }
  };

  const uploadTrailer = async (id, file) => {
    setUploadingTrailer(u => ({ ...u, [id]: true }));
    try {
      const fd = new FormData();
      fd.append('trailer', file);
      const r = await api.post(`/admin/game-catalog/${id}/upload-trailer`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setList(l => l.map(g => g.id === id ? { ...g, trailer_url: r.data.trailer_path } : g));
    } catch (e) {
      alert(e.response?.data?.error || 'Yuklashda xatolik');
    } finally {
      setUploadingTrailer(u => ({ ...u, [id]: false }));
    }
  };

  const coverSrc = (url) => {
    if (!url) return null;
    return url.startsWith('http') ? url : `${BASE_URL}${url}`;
  };

  const trailerSrc = (url) => {
    if (!url) return null;
    return url.startsWith('http') ? url : `${BASE_URL}${url.split('?')[0]}`;
  };

  const youtubeEmbed = (url) => {
    if (!url) return null;
    const m = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{11})/);
    return m ? `https://www.youtube.com/embed/${m[1]}?autoplay=1` : null;
  };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ margin: '0 0 16px', fontSize: 20, fontWeight: 700 }}>🎮 Katalog boshqaruvi</h2>

      <input value={q} onChange={e => setQ(e.target.value)}
        placeholder="🔍 Nom yoki slug bo'yicha qidirish..."
        style={{ width: '100%', maxWidth: 400, padding: '8px 12px', borderRadius: 8, fontSize: 13,
          background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', marginBottom: 16 }} />

      {loading ? (
        <div style={{ color: 'var(--text3)', padding: 40, textAlign: 'center' }}>Yuklanmoqda...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
          {filtered.map(g => (
            <div key={g.id} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
              {/* Cover */}
              <div style={{ position: 'relative', height: 120, background: 'var(--bg2)' }}>
                {coverSrc(g.cover_url) ? (
                  <img src={coverSrc(g.cover_url)} alt={g.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>🎮</div>
                )}
                <label style={{
                  position: 'absolute', bottom: 6, right: 6,
                  background: uploading[g.id] ? 'rgba(0,0,0,0.8)' : 'rgba(124,58,237,0.85)',
                  color: '#fff', borderRadius: 6, padding: '4px 8px', fontSize: 11,
                  cursor: 'pointer', fontWeight: 600,
                }}>
                  {uploading[g.id] ? '⏳' : '📷 Rasm'}
                  <input type="file" accept="image/*" style={{ display: 'none' }}
                    onChange={e => e.target.files[0] && uploadCover(g.id, e.target.files[0])} />
                </label>
                <label style={{
                  position: 'absolute', bottom: 6, left: 6,
                  background: uploadingTrailer[g.id] ? 'rgba(0,0,0,0.8)' : 'rgba(0,150,80,0.85)',
                  color: '#fff', borderRadius: 6, padding: '4px 8px', fontSize: 11,
                  cursor: 'pointer', fontWeight: 600,
                }}>
                  {uploadingTrailer[g.id] ? '⏳' : '🎬 Video'}
                  <input type="file" accept="video/*" style={{ display: 'none' }}
                    onChange={e => e.target.files[0] && uploadTrailer(g.id, e.target.files[0])} />
                </label>
              </div>

              {/* Info */}
              <div style={{ padding: '10px 12px' }}>
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 8 }}>
                  <span style={{ marginRight: 6, background: 'rgba(74,222,128,0.15)', color: '#4ade80', padding: '1px 5px', borderRadius: 4 }}>{g.platform || '—'}</span>
                  <span style={{ background: 'rgba(0,212,255,0.12)', color: 'var(--cyan)', padding: '1px 5px', borderRadius: 4 }}>{g.genre || '—'}</span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {g.trailer_url && (
                    <button onClick={() => setPreview(g)} style={{
                      flex: 1, padding: '5px 0', borderRadius: 7, fontSize: 11, cursor: 'pointer',
                      background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.5)', color: '#f87171',
                    }}>▶ Trailer</button>
                  )}
                  <button onClick={() => openEdit(g)} style={{
                    flex: 2, padding: '5px 0', borderRadius: 7, fontSize: 11, cursor: 'pointer',
                    background: 'rgba(0,212,255,0.08)', border: '1px solid var(--cyan)', color: 'var(--cyan)',
                  }}>✏️ Tahrirlash</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Trailer Preview Modal */}
      {preview && (
        <div onClick={() => setPreview(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: '90vw', maxWidth: 900, position: 'relative' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{preview.name}</span>
              <button onClick={() => setPreview(null)} style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer' }}>✕</button>
            </div>
            {youtubeEmbed(preview.trailer_url) ? (
              <iframe
                src={youtubeEmbed(preview.trailer_url)}
                style={{ width: '100%', aspectRatio: '16/9', border: 'none', borderRadius: 10 }}
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            ) : (
              <div>
                <video
                  src={trailerSrc(preview.trailer_url)}
                  controls autoPlay muted
                  style={{ width: '100%', borderRadius: 10, maxHeight: '75vh' }}
                  onError={e => { e.target.style.display='none'; e.target.parentNode.querySelector('.vid-err').style.display='block'; }}
                />
                <div className="vid-err" style={{ display:'none', color:'#f87171', padding:20, textAlign:'center', fontSize:12 }}>
                  Video yuklanmadi — {trailerSrc(preview.trailer_url)}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editing && (
        <div onClick={() => setEditing(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, width: 480, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 15 }}>✏️ Tahrirlash</h3>
              <button onClick={() => setEditing(null)} style={{ background: 'transparent', border: 'none', color: 'var(--text2)', fontSize: 20, cursor: 'pointer' }}>✕</button>
            </div>

            {[
              ['Nom', 'name'], ['Slug', 'slug'], ['Platform', 'platform'],
              ['Janr', 'genre'], ['Nashriyot', 'publisher'],
              ['Cover URL', 'cover_url'], ['Trailer URL', 'trailer_url'],
            ].map(([label, key]) => (
              <div key={key} style={{ marginBottom: 10 }}>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>{label}</div>
                <input value={form[key] || ''} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12,
                    background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', boxSizing: 'border-box' }} />
              </div>
            ))}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
              <div>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>Yosh chegarasi</div>
                <input type="number" value={form.age_rating} onChange={e => setForm(f => ({ ...f, age_rating: parseInt(e.target.value) || 0 }))}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 3 }}>Tartib</div>
                <input type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order: parseInt(e.target.value) || 0 }))}
                  style={{ width: '100%', padding: '7px 10px', borderRadius: 7, fontSize: 12, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', boxSizing: 'border-box' }} />
              </div>
            </div>

            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, marginBottom: 16, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm(f => ({ ...f, is_active: e.target.checked }))} />
              Faol
            </label>

            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => setEditing(null)} style={{ flex: 1, padding: 10, borderRadius: 8, fontSize: 12, cursor: 'pointer', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)' }}>Bekor</button>
              <button onClick={save} disabled={saving} style={{ flex: 2, padding: 10, borderRadius: 8, fontSize: 12, cursor: 'pointer', background: 'rgba(124,58,237,0.2)', border: '1px solid var(--purple)', color: 'var(--purple)', fontWeight: 700, opacity: saving ? 0.6 : 1 }}>
                {saving ? 'Saqlanmoqda...' : '💾 Saqlash'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
